import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { BaseResponse } from 'types/utils'

import { TicketList } from '../types'

export const ticketsQueryKey = ['tickets']

export function useTickets(params?: Record<string, string>) {
  async function getTickets() {
    const res = await apiClient.get<BaseResponse<TicketList>>(
      `${SNA_PREFIX}tickets/`,
      { params }
    )
    return res.data
  }

  return useQuery({
    queryFn: getTickets,
    queryKey: [...ticketsQueryKey, params]
  })
}
